import { OrderedMap } from 'immutable'
import { normalize, schema } from 'normalizr'
import { createReducer } from '@cheesecakelabs/boilerplate/utils'

import {
  GET_TODAY_ITEMS,
  SET_TODAY_ITEMS_ORDER,
  DELETE_TODAY_ITEM,
  CREATE_TODAY_ITEM,
  UPDATE_TODAY_ITEM,
  UPDATE_TODAY_ITEM_DATE,
  COMPLETE_TODAY_ITEM,
  UNDO_TODAY_ITEM,
} from './actions'

export const INITIAL_STATE = new OrderedMap()

export const todayItemSchema = new schema.Entity('todayItem', {}, { idAttribute: '_id' })

export const todayItems = createReducer(INITIAL_STATE, {
  [GET_TODAY_ITEMS.FULFILLED]: (state, { payload }) =>
    new OrderedMap(normalize(payload, [todayItemSchema]).entities.todayItem),

  [SET_TODAY_ITEMS_ORDER.FULFILLED]: (state, { payload }) =>
    state.mergeDeep(normalize(payload, [todayItemSchema]).entities.todayItem),

  [DELETE_TODAY_ITEM.FULFILLED]: (state, { payload }) => state.delete(payload),

  [CREATE_TODAY_ITEM.FULFILLED]: (state, { payload }) =>
    state.mergeDeep(normalize(payload, [todayItemSchema]).entities.todayItem),

  [UPDATE_TODAY_ITEM.FULFILLED]: (state, { payload }) =>
    state.mergeDeep(normalize(payload, [todayItemSchema]).entities.todayItem),

  [UPDATE_TODAY_ITEM_DATE.FULFILLED]: (state, { payload }) =>
    state.mergeDeep(normalize(payload, [todayItemSchema]).entities.todayItem),

  [COMPLETE_TODAY_ITEM.FULFILLED]: (state, { payload }) =>
    state.mergeDeep(normalize(payload, [todayItemSchema]).entities.todayItem),

  [UNDO_TODAY_ITEM.FULFILLED]: (state, { payload }) =>
    state.mergeDeep(normalize(payload, [todayItemSchema]).entities.todayItem),
})



// WEBPACK FOOTER //
// ./src/modules/today-items/reducers.js